(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["featured-collection-ui"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('featured-collection-scroller')) {
  customElements.define('featured-collection-scroller', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      this.imageObserver?.disconnect();
      this.imageObserver = window.IntersectionObserver && !window.Shopify?.designMode ? new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            this.loadImages(entry.target);
            this.imageObserver.unobserve(entry.target);
          }
        });
      }, { rootMargin: '800px 0px' }) : null;
      const options = { signal: this.controller.signal };
      this.panels = [...this.querySelectorAll('[data-featured-panel]')];
      this.tabs = [...this.querySelectorAll('[data-featured-tab]')];
      this.previous = this.querySelector('[data-featured-prev]');
      this.next = this.querySelector('[data-featured-next]');
      const tablist = this.querySelector('[data-featured-tabs]');
      tablist?.setAttribute('role', 'tablist');
      this.tabs.forEach((tab, index) => {
        tab.setAttribute('role', 'tab');
        const panel = this.panels[index];
        panel.setAttribute('role', 'tabpanel');
        panel.setAttribute('aria-labelledby', tab.id);
        panel.tabIndex = 0;
        tab.addEventListener('click', () => this.select(index), options);
        tab.addEventListener('keydown', event => {
          const rtl = getComputedStyle(this).direction === 'rtl';
          let next;
          if (event.key === 'ArrowRight') next = index + (rtl ? -1 : 1);
          if (event.key === 'ArrowLeft') next = index + (rtl ? 1 : -1);
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = this.tabs.length - 1;
          if (next === undefined) return;
          event.preventDefault();
          next = (next + this.tabs.length) % this.tabs.length;
          this.select(next);
          this.tabs[next].focus({ preventScroll: true });
          this.tabs[next].scrollIntoView({ block: 'nearest', inline: 'nearest' });
        }, options);
      });
      this.panels.forEach(panel => panel.querySelector('[data-featured-products]').addEventListener('scroll', () => this.schedule(), { ...options, passive: true }));
      this.previous?.addEventListener('click', () => this.move(-1), options);
      this.next?.addEventListener('click', () => this.move(1), options);
      if (window.Shopify?.designMode) {
        document.addEventListener('shopify:block:select', event => {
          const index = this.panels.findIndex(panel => panel.dataset.blockId === event.detail?.blockId);
          if (index >= 0 && this.contains(event.target)) this.select(index);
        }, options);
      }
      this.resizeObserver?.disconnect();
      this.resizeObserver = new ResizeObserver(() => this.schedule());
      this.panels.forEach(panel => this.resizeObserver.observe(panel.querySelector('[data-featured-products]')));
      this.setAttribute('data-initialized', '');
      this.select(Math.min(this.activeIndex || 0, Math.max(0, this.panels.length - 1)));
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.resizeObserver?.disconnect();
      this.imageObserver?.disconnect();
      cancelAnimationFrame(this.frame);
      this.frame = null;
    }
    select(index) {
      this.activeIndex = index;
      // Insert the selected cards before revealing them so responsive sizing uses the real grid.
      const template = this.panels[index]?.querySelector('template[data-featured-cards]');
      if (template) template.replaceWith(template.content);
      this.panels.forEach((panel, i) => { panel.hidden = i !== index; });
      this.tabs.forEach((tab, i) => {
        tab.setAttribute('aria-selected', String(i === index));
        tab.tabIndex = i === index ? 0 : -1;
      });
      this.panels[index]?.querySelectorAll('[data-featured-products]').forEach(frame => {
        if (!frame.querySelector('[data-card-src]')) return;
        this.imageObserver ? this.imageObserver.observe(frame) : this.loadImages(frame);
      });
      this.schedule();
    }
    loadImages(frame) {
      frame.querySelectorAll('[data-card-src]').forEach(image => {
        if (image.dataset.cardSrcset) image.srcset = image.dataset.cardSrcset;
        image.src = image.dataset.cardSrc;
        image.removeAttribute('data-card-srcset');
        image.removeAttribute('data-card-src');
        image.removeAttribute('aria-hidden');
      });
    }
    schedule() {
      if (this.frame) return;
      this.frame = requestAnimationFrame(() => { this.frame = null; this.update(); });
    }
    update() {
      const panel = this.panels[this.activeIndex];
      const scroller = panel?.querySelector('[data-featured-products]');
      if (!scroller) return;
      const max = scroller.scrollWidth - scroller.clientWidth;
      const position = Math.min(max, Math.abs(scroller.scrollLeft));
      const stacked = scroller.classList.contains('featured-collection-scroller__products--stacked');
      if (this.previous) this.previous.disabled = stacked || position <= 1;
      if (this.next) this.next.disabled = stacked || position >= max - 1;
      const progress = panel.querySelector('[data-featured-progress]');
      if (progress) {
        progress.hidden = max <= 1;
        progress.style.setProperty('--featured-progress', `${(position + scroller.clientWidth) / scroller.scrollWidth * 100}%`);
      }
    }
    move(direction) {
      const scroller = this.panels[this.activeIndex]?.querySelector('[data-featured-products]');
      if (!scroller) return;
      const card = scroller.firstElementChild;
      const gap = parseFloat(getComputedStyle(scroller).columnGap) || 0;
      const step = (card?.getBoundingClientRect().width || scroller.clientWidth) + gap;
      const count = Math.max(1, Math.floor((scroller.clientWidth + gap + 1) / step));
      const max = Math.max(0, scroller.scrollWidth - scroller.clientWidth);
      const position = Math.min(max, Math.abs(scroller.scrollLeft));
      const group = step * count;
      const page = direction > 0 ? Math.floor(position / group + .001) + 1 : Math.ceil(position / group - .001) - 1;
      const target = Math.max(0, Math.min(max, page * group));
      const rtl = getComputedStyle(this).direction === 'rtl';
      scroller.scrollTo({ left: target * (rtl ? -1 : 1), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["footer-review-summary"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('footer-review-summary')) {
  customElements.define('footer-review-summary', class extends HTMLElement {
    connectedCallback() {
      const generation = this.generation = (this.generation || 0) + 1;
      this.observer = new IntersectionObserver(entries => {
        if (!entries.some(entry => entry.isIntersecting)) return;
        this.observer.disconnect();
        const render = value => {
          if (!this.isConnected || generation !== this.generation || !value || !Number.isFinite(value.rating) || value.rating < 1 || value.rating > 5 || !Number.isInteger(value.count) || value.count < 1) return;
          const rating = Number(value.rating.toFixed(2));
          const locale = document.documentElement.lang || 'en';
          const score = new Intl.NumberFormat(locale, { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(rating);
          this.querySelector('[data-footer-rating]').textContent = `${new Intl.NumberFormat(locale).format(value.count)} reviews`;
          const stars = this.querySelector('.footer__review-stars');
          stars.hidden = false;
          stars.setAttribute('aria-label', `${score} out of 5 stars`);
          this.querySelectorAll('.product-review-star').forEach((star, index) => star.style.setProperty('--star-fill', `${Math.round(Math.min(1, Math.max(0, rating - index)) * 100)}%`));
        };
        render(window.TFFCReviewsStats?.peek?.());
        window.TFFCReviewsStats?.get().then(render);
      }, { rootMargin: '200px' });
      this.observer.observe(this);
    }
    disconnectedCallback() { this.observer?.disconnect(); this.generation++; }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["homepage-fill-screen"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('homepage-fill-screen')) {
  customElements.define('homepage-fill-screen', class extends HTMLElement {
    connectedCallback() {
      this.root = this.parentElement;
      this.schedule = () => {
        if (this.frame !== undefined || !this.isConnected) return;
        this.frame = requestAnimationFrame(() => { this.frame = undefined; this.measure(); });
      };
      this.observer = new ResizeObserver(this.schedule);
      this.mutations = new MutationObserver(this.schedule);
      this.refresh = () => {
        const selector = '.shopify-section-group-header-group, .shopify-section--header, .shopify-section--announcement-bar, .shopify-section--trust-bar';
        this.headers = [...document.querySelectorAll(selector)].filter(node => !node.parentElement.closest(selector));
        this.observer.disconnect();
        this.mutations.disconnect();
        [this.root, ...this.headers].forEach(node => this.observer.observe(node, { box: 'border-box' }));
        this.headers.forEach(node => this.mutations.observe(node, { attributes: true, attributeFilter: ['style', 'class', 'hidden'] }));
        this.schedule();
      };
      window.addEventListener('resize', this.schedule);
      document.addEventListener('shopify:section:load', this.refresh);
      document.addEventListener('shopify:section:unload', this.refresh);
      this.refresh();
      this.measure();
    }
    measure() {
      if (!this.isConnected) return;
      const number = value => parseFloat(value) || 0;
      const headerHeight = this.headers.reduce((height, node) => {
        const box = node.getBoundingClientRect();
        if (!box.height) return height;
        const style = getComputedStyle(node);
        return height + box.height + number(style.marginTop) + number(style.marginBottom);
      }, 0);
      const style = getComputedStyle(this.root);
      const spacing = number(style.paddingTop) + number(style.paddingBottom) + number(style.borderTopWidth) + number(style.borderBottomWidth);
      const viewport = CSS.supports('height', '100svh') ? '100svh' : '100vh';
      const value = `max(0px, calc(${viewport} - ${Math.max(0, headerHeight) + spacing}px))`;
      if (this.root.style.getPropertyValue('--callout-screen-height') !== value) this.root.style.setProperty('--callout-screen-height', value);
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.frame = undefined;
      this.observer?.disconnect();
      this.mutations?.disconnect();
      window.removeEventListener('resize', this.schedule);
      document.removeEventListener('shopify:section:load', this.refresh);
      document.removeEventListener('shopify:section:unload', this.refresh);
      this.root?.style.removeProperty('--callout-screen-height');
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["homepage-review-runtime"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('homepage-customer-reviews')) {
  customElements.define('homepage-customer-reviews', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.scroller = this.querySelector('[data-review-scroller]');
      this.previous = this.querySelector('[data-review-prev]');
      this.next = this.querySelector('[data-review-next]');
      if (!this.scroller) return;
      if (this.hasAttribute('randomize') && !window.Shopify?.designMode && !this.randomized) {
        const cards = [...this.scroller.children];
        for (let i = cards.length - 1; i > 0; i--) {
          const j = Math.floor(Math.random() * (i + 1));
          [cards[i], cards[j]] = [cards[j], cards[i]];
        }
        this.scroller.append(...cards);
        this.randomized = true;
      }
      this.scroller.addEventListener('scroll', () => this.schedule(), { ...options, passive: true });
      this.scroller.addEventListener('keydown', event => {
        if (event.target !== this.scroller) return;
        const rtl = getComputedStyle(this).direction === 'rtl';
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          this.move((event.key === 'ArrowRight' ? 1 : -1) * (rtl ? -1 : 1));
        } else if (event.key === 'Home' || event.key === 'End') {
          event.preventDefault();
          const end = Math.max(0, this.scroller.scrollWidth - this.scroller.clientWidth);
          this.scroller.scrollTo({ left: event.key === 'Home' ? 0 : end * (rtl ? -1 : 1), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        }
      }, options);
      this.previous?.addEventListener('click', () => this.move(-1), options);
      this.next?.addEventListener('click', () => this.move(1), options);
      if (window.Shopify?.designMode) {
        document.addEventListener('shopify:block:select', event => {
          const card = [...this.scroller.children].find(card => card.dataset.blockId === event.detail?.blockId);
          if (!card || !this.contains(event.target)) return;
          const rtl = getComputedStyle(this).direction === 'rtl';
          const box = this.scroller.getBoundingClientRect(), rect = card.getBoundingClientRect();
          this.scroller.scrollBy({ left: rtl ? rect.right - box.right : rect.left - box.left, behavior: 'auto' });
        }, options);
      }
      this.resizeObserver?.disconnect();
      this.resizeObserver = new ResizeObserver(() => this.schedule());
      this.resizeObserver.observe(this.scroller);
      this.setAttribute('data-enhanced', '');
      this.schedule();
      this.loadSummary();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.resizeObserver?.disconnect();
      this.summaryObserver?.disconnect();
      this.generation = (this.generation || 0) + 1;
      cancelAnimationFrame(this.frame);
      this.frame = null;
    }
    schedule() {
      if (this.frame) return;
      this.frame = requestAnimationFrame(() => { this.frame = null; this.update(); });
    }
    update() {
      const max = Math.max(0, this.scroller.scrollWidth - this.scroller.clientWidth);
      const position = Math.min(max, Math.abs(this.scroller.scrollLeft));
      if (this.previous) this.previous.disabled = position <= 1;
      if (this.next) this.next.disabled = position >= max - 1;
      const progress = this.querySelector('[data-review-progress]');
      if (progress) {
        progress.hidden = max <= 1;
        progress.style.setProperty('--reviews-progress', `${(position + this.scroller.clientWidth) / this.scroller.scrollWidth * 100}%`);
      }
    }
    move(direction) {
      const gap = parseFloat(getComputedStyle(this.scroller).columnGap) || 0;
      const step = (this.scroller.firstElementChild?.getBoundingClientRect().width || this.scroller.clientWidth) + gap;
      const count = Math.max(1, Math.floor((this.scroller.clientWidth + gap + 1) / step));
      const max = Math.max(0, this.scroller.scrollWidth - this.scroller.clientWidth);
      const position = Math.min(max, Math.abs(this.scroller.scrollLeft));
      const group = step * count;
      const page = direction > 0 ? Math.floor(position / group + .001) + 1 : Math.ceil(position / group - .001) - 1;
      const target = Math.max(0, Math.min(max, page * group));
      const rtl = getComputedStyle(this).direction === 'rtl';
      this.scroller.scrollTo({ left: target * (rtl ? -1 : 1), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    }
    loadSummary() {
      const summary = this.querySelector('[data-review-summary]');
      this.summaryObserver?.disconnect();
      const generation = this.generation = (this.generation || 0) + 1;
      if (!summary) return;
      this.summaryObserver = new IntersectionObserver(entries => {
        if (!entries.some(entry => entry.isIntersecting)) return;
        this.summaryObserver.disconnect();
        const render = value => {
          if (!this.isConnected || generation !== this.generation || !value || !Number.isFinite(value.rating) || value.rating < 1 || value.rating > 5 || !Number.isInteger(value.count) || value.count < 1) return;
          const rating = Number(value.rating.toFixed(2));
          const locale = document.documentElement.lang || 'en';
          const score = new Intl.NumberFormat(locale, { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(rating);
          const count = new Intl.NumberFormat(locale).format(value.count);
          summary.querySelector('[data-review-score]').textContent = summary.dataset.format.replace('[rating]', score).replace('[count]', count);
          const stars = summary.querySelector('.homepage-reviews__stars');
          stars.setAttribute('aria-label', summary.dataset.ratingFormat.replace('[rating]', score));
          stars.querySelectorAll('.product-review-star').forEach((star, index) => star.style.setProperty('--star-fill', `${Math.round(Math.min(1, Math.max(0, rating - index)) * 100)}%`));
          const aggregate = summary.querySelector('[data-review-aggregate]');
          aggregate.setAttribute('data-ready', '');
          aggregate.removeAttribute('aria-hidden');
        };
        render(window.TFFCReviewsStats?.peek?.());
        window.TFFCReviewsStats?.get().then(render);
      }, { rootMargin: '200px' });
      this.summaryObserver.observe(summary);
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-recommendation-ui"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('complete-look-prices')) {
    customElements.define('complete-look-prices', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        document.addEventListener('shopify:section:load', () => this.updatePrices(), { signal: this.controller.signal });
        queueMicrotask(() => {
          if (!this.isConnected) return;
          this.setupScroll();
          this.updatePrices();
        });
      }
      setupScroll() {
        this.scroller = this.querySelector('.complete-look__products');
        if (!this.scroller) return;
        this.scroller.addEventListener('dragstart', event => event.preventDefault(), { signal: this.controller.signal });
        this.scroller.addEventListener('pointerdown', event => {
          if (event.pointerType !== 'mouse' || event.button !== 0 || this.scroller.scrollWidth <= this.scroller.clientWidth + 1) return;
          clearTimeout(this.dragReset);
          this.dragPointer = event.pointerId;
          this.dragStart = event.clientX;
          this.dragScrollStart = this.scroller.scrollLeft;
          this.dragged = false;
        }, { signal: this.controller.signal });
        this.scroller.addEventListener('pointermove', event => {
          if (event.pointerId !== this.dragPointer) return;
          const distance = event.clientX - this.dragStart;
          if (!this.dragged) {
            if (Math.abs(distance) < 8) return;
            this.dragged = true;
            this.scroller.setPointerCapture(event.pointerId);
            this.scroller.toggleAttribute('data-dragging', true);
          }
          this.scroller.scrollLeft = this.dragScrollStart - distance;
          event.preventDefault();
        }, { signal: this.controller.signal });
        const finishDrag = event => {
          if (event.pointerId !== this.dragPointer) return;
          if (this.scroller.hasPointerCapture(event.pointerId)) this.scroller.releasePointerCapture(event.pointerId);
          this.dragPointer = null;
          this.scroller.removeAttribute('data-dragging');
          this.dragReset = setTimeout(() => { this.dragged = false; }, 0);
        };
        this.scroller.addEventListener('pointerup', finishDrag, { signal: this.controller.signal });
        this.scroller.addEventListener('pointercancel', finishDrag, { signal: this.controller.signal });
        this.scroller.addEventListener('click', event => {
          if (!this.dragged) return;
          event.preventDefault();
          event.stopPropagation();
          this.dragged = false;
        }, { capture: true, signal: this.controller.signal });
      }
      disconnectedCallback() { this.controller?.abort(); clearTimeout(this.dragReset); }
      updatePrices() {
        const pdp = document.querySelector('modular-product[data-display-discount]');
        if (!pdp || pdp.dataset.productId !== this.dataset.productId) return;
        const discount = Math.min(100, Math.max(0, Number(pdp.dataset.displayDiscount) || 0));
        const money = new Intl.NumberFormat(document.documentElement.lang || 'en-GB', { style: 'currency', currency: pdp.dataset.currency || 'GBP', minimumFractionDigits: 2, maximumFractionDigits: 2 });
        this.querySelectorAll('[data-card-price]').forEach(card => {
          const original = Number(card.dataset.price);
          const percent = card.dataset.vase === 'true' && pdp.dataset.discountVase !== 'true' ? 0 : discount;
          const price = Math.floor((original * (100 - percent) + 50) / 100);
          const compare = percent > 0 ? original : Number(card.dataset.comparePrice);
          card.querySelector('[data-amount]').textContent = money.format(price / 100);
          const comparison = card.querySelector('[data-compare]');
          comparison.textContent = compare > price ? money.format(compare / 100) : '';
          comparison.hidden = compare <= price;
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["reviews-page-runtime"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('reviews-page-summary')) {
  customElements.define('reviews-page-summary', class extends HTMLElement {
    connectedCallback() {
      const generation = this.generation = (this.generation || 0) + 1;
      const render = value => {
        if (!this.isConnected || generation !== this.generation || !value) return;
        const rating = Number(value.rating.toFixed(2));
        const score = rating.toFixed(2);
        const count = new Intl.NumberFormat(document.documentElement.lang || 'en').format(value.count);
        this.querySelector('[data-score]').textContent = score;
        this.querySelector('[data-count]').textContent = this.dataset.countFormat.replace('[count]', count);
        const stars = this.querySelector('.homepage-reviews__stars');
        stars.setAttribute('aria-label', this.dataset.ratingFormat.replace('[rating]', score));
        stars.querySelectorAll('.product-review-star').forEach((star, index) => star.style.setProperty('--star-fill', `${Math.round(Math.min(1, Math.max(0, rating - index)) * 100)}%`));
        const aggregate = this.querySelector('[data-review-aggregate]');
        aggregate.removeAttribute('aria-hidden');
        aggregate.setAttribute('data-ready', '');
      };
      render(window.TFFCReviewsStats?.peek?.());
      window.TFFCReviewsStats?.get().then(render);
    }
    disconnectedCallback() { this.generation++; }
  });
}
if (!customElements.get('reviews-page-feed')) {
  let hostSequence = 0;
  customElements.define('reviews-page-feed', class extends HTMLElement {
    connectedCallback() {
      this.generation = (this.generation || 0) + 1;
      this.controller?.abort();
      this.controller = new AbortController();
      this.observer = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) { this.wanted = true; this.activate(); }
      }, { rootMargin: '300px' });
      this.observer.observe(this);
      document.addEventListener('visitorConsentCollected', () => {
        if (window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === false) this.reset();
        else if (this.wanted) this.activate();
      }, { signal: this.controller.signal });
    }
    async activate() {
      if (this.loading || this.mounted || !this.isConnected || window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === false) return;
      this.loading = true;
      this.querySelector('[data-feed-loading]').hidden = false;
      const generation = this.generation;
      try {
        LibraryLoader.libraries.reviewsPolaris ||= { tagId: 'reviews-polaris', src: 'https://widget.reviews.io/polaris/build.js', type: 'script' };
        LibraryLoader.libraries.reviewsStyles ||= { tagId: 'reviews-styles', src: 'https://assets.reviews.io/css/widgets/elements-widget.css?version=200', type: 'link' };
        LibraryLoader.libraries.reviewsIcons ||= { tagId: 'reviews-icons', src: 'https://assets.reviews.io/iconfont/reviewsio-icons/style.css?version=200', type: 'link' };
        await Promise.all(['reviewsStyles', 'reviewsIcons'].map(name => LibraryLoader.load(name)).concat(typeof window.ReviewsWidget === 'function' ? [] : [LibraryLoader.load('reviewsPolaris')]));
        if (!this.isConnected || generation !== this.generation || window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === false) return;
        const host = this.querySelector('[data-feed-host]');
        host.id = `ReviewsPageFeed-${++hostSequence}`;
        this.widgetHost = host;
        const styles = {
          '--base-font-size': 'var(--body-large-font-size)',
          '--body-text-font-family': 'var(--text-font-family)', '--body-text-font-size': 'var(--body-large-font-size)',
          '--body-text-font-weight': 'var(--text-font-weight)', '--body-text-line-height': 'var(--body-line-height)',
          '--body-text-color': 'rgb(var(--text-color))', '--heading-text-color': 'rgb(var(--heading-color))',
          '--heading-text-font-family': 'var(--text-font-family)', '--heading-text-font-weight': 'var(--text-font-bold-weight)',
          '--common-star-color': 'var(--review-star-color)', '--common-star-disabled-color': 'var(--control-border-color)',
          '--common-border-color': 'var(--control-border-color)', '--common-border-width': '1px',
          '--common-button-font-family': 'var(--text-font-family)', '--common-button-font-size': 'var(--button-font-size)',
          '--common-button-font-weight': 'var(--text-font-bold-weight)', '--common-button-border-radius': '0px',
          '--primary-button-bg-color': 'rgb(var(--text-color))', '--primary-button-text-color': 'rgb(var(--background))',
          '--secondary-button-bg-color': 'transparent', '--secondary-button-border-color': 'var(--control-border-color)',
          '--secondary-button-text-color': 'rgb(var(--text-color))', '--author-font-size': '15px',
          '--badge-text-font-size': '13px', '--badge-icon-font-size': '18px', '--badge-text-color': 'rgb(var(--text-color))',
          '--badge-icon-color': 'rgb(var(--text-color))', '--inputfield-text-font-family': 'var(--text-font-family)',
          '--inputfield-text-color': 'rgb(var(--text-color))', '--inputfield-border-color': 'var(--control-border-color)',
          '--inputfield-background-color': 'transparent', '--filters-panel-bg-color': 'transparent',
          '--filters-panel-font-size': 'var(--font-size-small)', '--pagination-tab-text-font-size': 'var(--body-font-size)',
          '--pagination-tab-text-color': 'rgb(var(--text-color))', '--pagination-tab-active-text-color': 'rgb(var(--text-color))',
          '--pagination-tab-active-border-color': 'rgb(var(--text-color))'
        };
        this.mountObserver = new MutationObserver(() => {
          if (generation !== this.generation || !this.isConnected) { this.clean(host); return; }
          if (host.querySelector('.R-ContentList__item')) { this.querySelector('[data-feed-loading]').hidden = true; clearTimeout(this.deadline); }
        });
        this.mountObserver.observe(host, { childList: true, subtree: true });
        new ReviewsWidget('#' + host.id, {
          store: 'www.amaranthineblooms.co.uk', widget: 'polaris', styles,
          options: {
            types: this.dataset.types, lang: document.documentElement.lang || 'en', per_page: Number(this.dataset.perPage) || 10,
            product_review: { sku: '', enable_rich_snippets: false }, store_review: { hide_if_no_results: true },
            header: { enable_summary: true, enable_ratings: true, enable_attributes: false, enable_image_gallery: this.dataset.gallery === 'true', enable_percent_recommended: false, enable_write_review: false, enable_ask_question: false, enable_sub_header: true, rating_decimal_places: 2 },
            filtering: { enable: true, enable_text_search: false, enable_sorting: true, enable_product_filter: false, enable_media_filter: true, enable_overall_rating_filter: true, enable_language_filter: false, enable_ratings_filters: false, enable_attributes_filters: false },
            reviews: { enable_avatar: false, enable_reviewer_name: true, enable_reviewer_address: false, enable_verified_badge: true, review_content_filter: 'no_comments', enable_reviewer_recommends: false, enable_attributes: false, enable_product_name: true, enable_replies: true, enable_images: true, enable_ratings: true, enable_share: false, enable_helpful_vote: false, enable_helpful_display: false, enable_report: false, enable_date: true, enable_duplicate_reviews: false }
          }
        });
        this.mounted = true;
        this.deadline = setTimeout(() => {
          if (this.isConnected && generation === this.generation) this.querySelector('[data-feed-loading]').hidden = true;
        }, 15000);
      } catch (_) { }
      finally {
        if (generation === this.generation) {
          this.loading = false;
          if (!this.mounted) this.querySelector('[data-feed-loading]').hidden = true;
        }
      }
    }
    clean(host) {
      for (const node of host.querySelectorAll('[data-v-app]')) {
        try { node.__vue_app__?.unmount?.(); } catch (_) { }
        if (window.ReviewsWidgetInstances) delete window.ReviewsWidgetInstances[node.id];
      }
      if (Array.isArray(window.__reviewsIoWidgetList)) {
        for (let i = window.__reviewsIoWidgetList.length - 1; i >= 0; i--) {
          if (window.__reviewsIoWidgetList[i].target === '#' + host.id) window.__reviewsIoWidgetList.splice(i, 1);
        }
      }
      document.getElementById('reviews-io-polaris-modal-' + host.id.replace(/[^a-z0-9]/gi, ''))?.remove();
      if (host.hasChildNodes()) host.replaceChildren();
    }
    reset() {
      this.generation++;
      clearTimeout(this.deadline);
      this.mountObserver?.disconnect();
      const host = this.widgetHost;
      if (host) {
        this.clean(host);
        const lateMount = new MutationObserver(() => this.clean(host));
        lateMount.observe(host, { childList: true, subtree: true });
        setTimeout(() => lateMount.disconnect(), 20000);
        const replacement = document.createElement('div');
        replacement.dataset.feedHost = '';
        host.replaceWith(replacement);
      }
      this.widgetHost = null;
      this.loading = this.mounted = false;
      this.querySelector('[data-feed-loading]').hidden = true;
    }
    disconnectedCallback() { this.controller?.abort(); this.observer?.disconnect(); this.reset(); }
  });
}
  } catch(e) { console.error(e); }
})();

})();
